import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { T } from 'src/shared/helpers';
import { Dialog, useDialogManager } from '../../../../widgets/dialog';
import { Checkbox } from '../../../../widgets/checkbox';

export interface DuplicateOptions {
    cloneTemplates: boolean;
    assignPricingRules: boolean;
}

const OptionsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 8px 0 16px;
`;

const DuplicateOptionsDialog: FC<{
    dialogId: string;
    onConfirm: (options: DuplicateOptions) => void;
    onCancel?: () => void;
}> = ({ dialogId, onConfirm, onCancel }) => {
    const [cloneTemplates, setCloneTemplates] = useState(false);
    const [assignPricingRules, setAssignPricingRules] = useState(false);
    const { closeDialog } = useDialogManager();

    const handleCancel = () => {
        closeDialog(dialogId);
        onCancel?.();
    };

    const handleConfirm = () => {
        closeDialog(dialogId);
        onConfirm({ cloneTemplates, assignPricingRules });
    };

    return (
        <Dialog
            title={T._('Duplication options', 'Admin')}
            onClose={handleCancel}
            buttons={[
                { label: T._('Cancel', 'Admin'), outline: true, onClick: handleCancel },
                { label: T._('Duplicate', 'Admin'), onClick: handleConfirm }
            ]}
        >
            <OptionsList>
                <Checkbox
                    checked={cloneTemplates}
                    onChange={setCloneTemplates}
                    label={T._('Clone templates', 'Admin')}
                    caption={T._('Copy the design templates from the source product to the new ones.', 'Admin')}
                />
                <Checkbox
                    checked={assignPricingRules}
                    onChange={setAssignPricingRules}
                    label={T._('Assign pricing rules', 'Admin')}
                    caption={T._('Add the new products to the same pricing groups as the source product.', 'Admin')}
                />
            </OptionsList>
        </Dialog>
    );
};

export default DuplicateOptionsDialog;
